import { DirectUpload as DirectUploadController } from 'activestorage'
import classNames from 'classnames'
import React, { useCallback, useMemo, useRef, useState } from 'react'
import { Button } from 'semantic-ui-react'
import { FormInputError } from 'shared'
import styles from './direct_upload.module.css'
import { DirectUploadProps } from './types'
const UPLOAD_URL = '/rails/active_storage/direct_uploads'

const DirectUpload = ({
  content = 'Hello',
  error,
  onUpload,
  triggerComponent: Trigger = Button,
  className,
  loading: loading_, // TODO: Pass mutation loading flag
}: DirectUploadProps) => {
  const [busy, setBusy] = useState(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null)

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = useCallback(
    (event) => {
      const file = event?.target?.files && event.target.files[0]
      if (!file) return

      setBusy(true)
      const controller = new DirectUploadController(file, UPLOAD_URL, this)
      controller.create((error, attributes) => {
        if (!error) onUpload(attributes.signed_id, URL.createObjectURL(file))
        setBusy(false)
      })
    },
    [onUpload]
  )

  const loading = useMemo(() => loading_ || busy, [loading_, busy])
  const handleTriggerClick: React.MouseEventHandler = useCallback((event) => {
    event.preventDefault()
    fileInputRef.current && fileInputRef.current.click()
  }, [])

  return (
    <div className={classNames(styles.buttonContainer, className, { ['error']: !!error })}>
      {error && (
        <div>
          <FormInputError errorSymbol={error} />
        </div>
      )}
      <div className={classNames('ui', 'input', styles.input, className)}>
        <input
          type="file"
          accept=".jpg,.jpeg,.png"
          onChange={handleFileChange}
          style={{ display: 'none' }}
          ref={fileInputRef}
        />
        <Trigger onClick={handleTriggerClick} content={content} loading={loading} primary />
      </div>
    </div>
  )
}

export default DirectUpload
